// vendors
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'mode-notebook-toolbar-more-dropdown',
  templateUrl: './notebook-toolbar-more-dropdown.component.html',
  styleUrls: ['./notebook-toolbar-more-dropdown.component.scss'],
})
export class NotebookToolbarMoreDropdownComponent {
  @ViewChild(CdkConnectedOverlay) connectedOverlayDirective!: CdkConnectedOverlay;

  @Input()
  exportLink!: string;

  @Input()
  disableHideOutput = false;

  @Output()
  hideOutput: EventEmitter<void> = new EventEmitter();

  isDialogOpen = false;

  constructor() {}

  hideOutputAndClose() {
    this.hideOutput.emit();
    this.closeDialog();
  }

  closeDialog() {
    setTimeout(() => (this.isDialogOpen = false));
  }
}
